var DK = DK || {};
DK.Recommendations = DK.Recommendations || {};
DK.Recommendations.initCarousel = function ($carouselParent) {
  $carouselParent.find('.product').removeClass('col-md-3 col-sm-4 col-6 mb-4');
  // Ok this is ugly BUT, the modal and listing page
  // Have different allotments of space thus needing
  // different number of products.
  if ($carouselParent.data('recModal')) {
    $carouselParent.find('ul').lightSlider({
      item: 4,
      loop: false,
      slideMove: 4,
      speed: 600,
      easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
      responsive: [{
        breakpoint: 991,
        settings: {
          item: 4,
          slideMove: 4,
          slideMargin: 6
        }
      }, {
        breakpoint: 767,
        settings: {
          item: 3,
          slideMove: 1,
          freeMove: true
        }
      }, {
        breakpoint: 575,
        settings: {
          item: 2,
          slideMove: 1,
          freeMove: true
        }
      }],
      onSliderLoad: function (el) {
        const lazyImages = el.find('img.lazy');
        if (lazyImages.length > 0) {
          lazyImages.show().lazyload({
            effect: 'fadeIn',
            // use a 1px invisible image as a placeholder instead of a
            // grey image (which is the default)
            placeholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH3gkTDTUoNAC04AAAAA1JREFUCNdj+P//PwMACPwC/lyfz9oAAAAASUVORK5CYII=',
            threshold: 200,
            container: el
          });
        }
        // Need to refresh the slider after lazy loading
        // images so that the height is correct
        el.refresh();
      }
    });
  } else {
    $carouselParent.find('ul').lightSlider({
      item: 6,
      loop: false,
      slideMove: 6,
      speed: 600,
      easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
      responsive: [{
        breakpoint: 1100,
        settings: {
          item: 5,
          slideMove: 5,
          slideMargin: 6
        }
      }, {
        breakpoint: 991,
        settings: {
          item: 4,
          slideMove: 4,
          slideMargin: 6
        }
      }, {
        breakpoint: 767,
        settings: {
          item: 3,
          slideMove: 1,
          freeMove: true
        }
      }, {
        breakpoint: 575,
        settings: {
          item: 2,
          slideMove: 1,
          freeMove: true
        }
      }],
      onSliderLoad: function (el) {
        const lazyImages = el.find('img.lazy');
        if (lazyImages.length > 0) {
          lazyImages.show().lazyload({
            effect: 'fadeIn',
            // use a 1px invisible image as a placeholder instead of a
            // grey image (which is the default)
            placeholder: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH3gkTDTUoNAC04AAAAA1JREFUCNdj+P//PwMACPwC/lyfz9oAAAAASUVORK5CYII=',
            threshold: 200,
            container: el
          });
        }
        // Need to refresh the slider after lazy loading
        // images so that the height is correct
        el.refresh();
      }
    });
  }
  $carouselParent.addClass('show');
};
$(function () {
  if (!$('.product-details-page').length) {
    $('[data-rec-container]').each((i, el) => DK.Recommendations.initCarousel($(el)));
  }
});